import { Component, Input } from "@angular/core";
import { RecordingJob } from "app/js/src/domain/recording-job";
import { ICellRendererAngularComp } from "ag-grid-angular";
@Component({
  selector: "evrideo-recording-job-actions",
  templateUrl: "./recording-job-actions.component.html",
  styleUrls: ["./recording-job-actions.component.scss"],
})
export class RecordingJobActionsComponent implements ICellRendererAngularComp {
  @Input() recordingJob: RecordingJob;
  public params: any;
  recordingIcon: string;
  isRunning = false;
  constructor() {}

  agInit(params: any): void {
    this.refresh(params);
  }
  refresh(params: any): boolean {
    this.params = params;
    this.recordingJob = params.node.data;
    this.isRunning = this.recordingJob.isRunning();
    this.setRecordingIcon();
    return true;
  }

  isRecurring() {
    return true;
  }

  setRecordingIcon() {
    this.recordingIcon = `/assets/icons/recording-${this.isRunning ? "stop" : "start"}.svg`;
  }

  public deleteJob() {
    this.params.context.componentParent.deleteJob(this.recordingJob);
  }
  public toggleJobRecording() {
    this.params.context.componentParent.toggleJobRecording(this.recordingJob);
  }

  public showJobSettings() {
    this.params.context.componentParent.showJobSettings(this.params.node.id);
  }
}
